import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04eb8d88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mine-base" }
const _hoisted_2 = {
  key: 0,
  class: "page-default page-media"
}
const _hoisted_3 = { class: "base-info" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_6 = { class: "mine-navigators c-secondary" }
const _hoisted_7 = { class: "user-page page-default page-media" }

import user, { State } from '@/store/user';
import Avatar from '@/views/components/Avatar.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Layout from '../movies/Root.vue';
import i18, { State as I18State } from '@/store/i18';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const route = useRoute()
const data = computed<State>(() => store.state[user.name]);
const current = computed(() => route.path)

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed<any>(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].mineText.menu)

const navigators = [
    { key: 'my_profile', path: '/mine' },
    { key: 'my_play', path: '/mine/playbacks' },
    { key: 'my_favorite', path: '/mine/favorites' },
    { key: 'my_note', path: '/mine/notes' },
    { key: 'notices', path: '/mine/news' },
    { key: 'about', path: '/mine/about' },
    { key: 'suggest', path: '/mine/suggest' },
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(Layout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(data).info)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(Avatar, {
                  url: _unref(data).info.avatar
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, [
                    _createElementVNode("b", null, _toDisplayString(_unref(data).info.nickname), 1)
                  ]),
                  _createElementVNode("div", null, _toDisplayString(_unref(data).info.username), 1)
                ]),
                _hoisted_5
              ]),
              _createElementVNode("div", _hoisted_6, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigators, (item) => {
                  return _createVNode(_component_router_link, {
                    class: _normalizeClass({ on: _unref(current) == item.path }),
                    to: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(lang)[item.key]), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "to"])
                }), 64))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_unref(data).info)
          ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})